import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const TaxCollectionReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    const [filterType, setFilterType] = useState('village'); // 'all', 'village', 'ward'
    const [selectedVillage, setSelectedVillage] = useState('इनाम धामणी');
    
    // Sample villages
    const villages = ['इनाम धामणी', 'गाव 2', 'गाव 3'];

    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            {/* Header */}
            <div className="bg-[#267c77] text-white p-4 md:p-6 shadow-lg">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
                    <div className="flex items-center gap-4 mb-4 md:mb-0">
                        <button
                            onClick={() => navigate(-1)}
                            className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-white/50"
                        >
                            <FiArrowLeft className="w-6 h-6" />
                        </button>
                        <div>
                            <h1 className="text-xl md:text-2xl font-bold">कर वसुल माहिती</h1>
                            <p className="text-white/80 text-xs md:text-sm">
                                {grampanchayatName || 'ग्रामपंचायत'} | आर्थिक वर्ष: {arthikVarshLabel || '२०२४-२५'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-7xl mx-auto p-4 md:p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    
                    {/* Left: Filter Section */}
                    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                        <div className="bg-[#267c77] text-white px-4 py-2 font-medium">
                            प्रमाणे
                        </div>
                        <div className="p-6 space-y-6">
                            <div className="flex flex-wrap gap-6">
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input 
                                        type="radio" 
                                        name="filterType" 
                                        className="w-4 h-4 text-[#267c77] focus:ring-[#267c77]"
                                        checked={filterType === 'all'}
                                        onChange={() => setFilterType('all')}
                                    />
                                    <span className="text-gray-700">सर्व</span>
                                </label>
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input 
                                        type="radio" 
                                        name="filterType" 
                                        className="w-4 h-4 text-[#267c77] focus:ring-[#267c77]"
                                        checked={filterType === 'village'}
                                        onChange={() => setFilterType('village')}
                                    />
                                    <span className="text-gray-700 font-medium">गावानुसार</span>
                                </label>
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input 
                                        type="radio" 
                                        name="filterType" 
                                        className="w-4 h-4 text-[#267c77] focus:ring-[#267c77]"
                                        checked={filterType === 'ward'}
                                        onChange={() => setFilterType('ward')}
                                    />
                                    <span className="text-gray-700">वार्डनुसार</span>
                                </label>
                            </div>

                            <div className="flex flex-col md:flex-row items-center gap-4">
                                <label className="whitespace-nowrap font-medium text-gray-700">गाव निवडा</label>
                                <select 
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#267c77] bg-white"
                                    value={selectedVillage}
                                    onChange={(e) => setSelectedVillage(e.target.value)}
                                >
                                    {villages.map((v, i) => (
                                        <option key={i} value={v}>{v}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex justify-center mt-4">
                                <button className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-8 py-2 rounded shadow transition-colors font-medium">
                                    दाखवा
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Right: Report/Table Section */}
                    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                        <div className="bg-[#267c77] text-white px-4 py-2 font-medium">
                            कर वसुल माहिती
                        </div>
                        <div className="p-4">
                            <div className="overflow-x-auto">
                                <table className="w-full text-sm text-left border-collapse border border-gray-300">
                                    <thead className="bg-[#267c77] text-white">
                                        <tr>
                                            <th className="px-4 py-2 border border-white/30">कर प्रकार</th>
                                            <th className="px-4 py-2 border border-white/30 text-center">मागील</th>
                                            <th className="px-4 py-2 border border-white/30 text-center">चालु</th>
                                            <th className="px-4 py-2 border border-white/30 text-center">एकुण</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        <tr className="hover:bg-gray-50">
                                            <td className="px-4 py-3 border border-gray-300 font-medium">पाणीपट्टी</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                        </tr>
                                        <tr className="hover:bg-gray-50">
                                            <td className="px-4 py-3 border border-gray-300 font-medium">खास पाणीपट्टी</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                        </tr>
                                        <tr className="bg-gray-100 font-bold">
                                            <td className="px-4 py-3 border border-gray-300">एकुण</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                            <td className="px-4 py-3 border border-gray-300 text-center">0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="flex justify-center mt-6">
                                <button 
                                    onClick={() => navigate('/panipuravtha/tax-collection/print', { state: location.state })}
                                    className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-8 py-2 rounded shadow transition-colors font-medium flex items-center gap-2"
                                >
                                    <span className="hidden md:inline">प्रिंट</span> रिपोर्ट
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaxCollectionReport;
